// src/components/ThemeToggle.jsx
// -----------------------------------------------------------------------------
// A compact theme toggle that lets the user flip between the new light and
// dark Speedway palettes while keeping the brand colors intact.
import React, { useMemo } from "react";
import { MoonStar, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { Button } from "@/components/ui/button";

export default function ThemeToggle() {
    const { resolvedTheme, setTheme } = useTheme();

    const isDark = resolvedTheme === "dark";

    const Icon = useMemo(() => (isDark ? Sun : MoonStar), [isDark]);

    const handleToggle = () => {
        setTheme(isDark ? "light" : "dark");
    };

    return (
        <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={handleToggle}
            className="relative h-9 w-9 rounded-full border border-border/80 bg-background/80 shadow-sm transition-colors duration-300 hover:bg-secondary/20"
            aria-label={isDark ? "Aktivera ljust tema" : "Aktivera mörkt tema"}
        >
            <Icon className="h-5 w-5 text-primary transition-transform duration-300" />
            <span className="sr-only">Toggle theme</span>
        </Button>
    );
}